import { ROUTES } from '@/router/routes'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

/**
 * True on `/app/ai-assistant` and nested paths (fullscreen KI-Assistent).
 *
 * @returns Computed flag derived from the current route path.
 */
export function useIsAiAssistantAppRoute() {
  const route = useRoute()
  return computed(() => {
    const prefix = ROUTES.APP.AI_ASSISTANT.ROOT
    return route.path === prefix || route.path.startsWith(`${prefix}/`)
  })
}
